// extracted by mini-css-extract-plugin
export default {"root":"PagesPanel_root__RvBri"};